import styled from 'styled-components';

export const LoadableIconWrapper = styled.span`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
`;
